import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import { SxProps, Theme } from '@mui/material/styles';
import { FieldValues, useController, UseControllerProps } from 'react-hook-form';

import Label from './Label';

type Props<T extends FieldValues> = UseControllerProps<T> & {
  isDisabled?: boolean;
  label?: React.ReactNode;
  sx?: SxProps<Theme>;
  // Fires only on user clicks (never on programmatic form writes), so callers
  // can hang side effects like analytics off the interaction itself.
  onValueChange?: (checked: boolean) => void;
};

export default function CheckboxInput<T extends FieldValues>({
  control,
  isDisabled,
  label,
  name,
  sx,
  onValueChange,
}: Props<T>) {
  const { field } = useController({ control, name });

  return (
    <FormControl disabled={isDisabled} fullWidth sx={sx}>
      <FormControlLabel
        control={
          <Checkbox
            checked={field.value ?? false}
            disabled={isDisabled}
            onChange={(e) => {
              field.onChange(e.target.checked);
              onValueChange?.(e.target.checked);
            }}
          />
        }
        label={label ? <Label>{label}</Label> : undefined}
      />
    </FormControl>
  );
}
